import { render, staticRenderFns } from "./EsgHRManage.vue?vue&type=template&id=06fbc72a&"
import script from "./EsgHRManage.vue?vue&type=script&lang=js&"
export * from "./EsgHRManage.vue?vue&type=script&lang=js&"
import style0 from "./EsgHRManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports